<template>
  <div :class="['row full-width justify-center', isMobile ? 'q-pt-md q-pb-lg' : 'q-py-lg']">
    <div :class="['row col-11 justify-between items-start', isMobile ? '' : 'q-px-sm']">

      <!-- categories, filter (desktop) -->
      <div v-if="!isMobile" class="col-12 col-md-3">
        <div class="row full-width">
          <div class="column full-width q-gutter-y-md">

            <!-- categories -->
            <div class="column border-radius border-solid bg-white q-pa-md text-grey-4">

              <!-- title -->
              <div class="q-px-sm">

                <!-- mobile -->
                <div v-if="isMobile" class="text-subtitle1 text-bold text-grey-9">
                  دسته بندی
                </div>

                <!-- desktop -->
                <h1 v-else class="text-bold text-grey-9">
                  دسته بندی
                </h1>

              </div>

              <!-- separator -->
              <q-separator class="q-mx-xs q-my-md"/>

              <!-- categories -->
              <div class="row full-width">
                <div class="column full-width q-gutter-y-sm">
                  <div v-for="(category, index) of categories"
                       class="row full-width justify-between items-center text-grey-9 hover-primary">

                    <q-checkbox
                      :class="['text-subtitle2 text-weight-regular', getFilterValue('projectGroupId',category.id) ? 'text-primary' : undefined]"
                      size="sm" :val="category.id"
                      :label="category.title" color="primary"
                      :model-value="getFilterValue('projectGroupId',category.id)"
                      @update:model-value="toggleCategoryFilter(category.id)"/>

                    <q-icon :name="category.icon" size="sm"
                            :color="getFilterValue('projectGroupId',category.id) ? 'primary' : undefined"/>

                  </div>
                </div>
              </div>

            </div>

            <!-- filters -->
            <div class="column border-radius border-solid bg-white q-pa-md text-grey-4">

              <!-- title -->
              <div class="text-subtitle1 text-bold text-grey-9 q-px-sm">
                فیلتر
              </div>

              <!-- separator -->
              <q-separator class="q-mx-xs q-my-md"/>

              <!-- filters -->
              <div class="row full-width">
                <div class="column q-gutter-y-xs">
                  <q-radio v-for="filter of progressFilters" class="text-subtitle2 text-weight-regular text-grey-9"
                           size="sm"
                           :val="filter.value"
                           :label="filter.label" color="primary"
                           v-model="selectedFilter"
                           @update:model-value="setProgressFilter"
                  />
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <!-- search, sorting, results -->
      <div :class="['col-12 col-md-9', isMobile ? '' : 'q-pl-md']">
        <div class="column full-width q-gutter-y-md">

          <!-- search, sorting -->
          <div class="column full-width border-radius border-solid bg-white q-mb-md q-pt-sm q-pb-md text-grey-4">

            <!-- search -->
            <div class="row full-width q-mb-md q-px-md q-pt-sm items-center">
              <div class="full-width border-radius q-px-md text-grey-4" style="border: 2px solid">
                <q-input class="full-width q-mx-none" color="secondary" label="جستجو"
                         borderless dense @update:model-value="searchCampaign($event)" v-model="search"
                         :debounce="500"/>
              </div>
            </div>

            <!-- sorting (desktop) -->
            <div v-if="!isMobile" class="row full-width q-mt-none q-px-sm q-gutter-x-sm items-center">

              <!-- icon -->
              <q-icon name="la la-sort-amount-down" size="sm" color="grey-7"/>

              <!-- label -->
              <div class="text-subtitle2 text-weight-regular text-grey-8">
                مرتب سازی بر اساس :
              </div>

              <!-- options -->
              <q-btn v-for="option of sortingOptions"
                     class="border-radius text-subtitle2 text-weight-regular q-px-sm"
                     :unelevated="option.value === sorting" :flat="option.value !== sorting"
                     color="secondary" :label="option.label" dense @click="setSort(option.value)"/>

            </div>

            <!-- categories, filters, sorting (mobile) -->
            <div v-else class="row full-width q-px-md justify-between items-center">

              <!-- categories -->
              <q-btn class="border-radius q-px-sm" size="12px" icon="la la-stream" label="دسته‌بندی" color="black" flat
                     dense @click="categoriesDialog = true"/>

              <q-dialog v-model="categoriesDialog" transition-show="scale" transition-hide="scale" full-width>
                <div class="column bg-white q-pa-md" style="border-radius: 10px">

                  <!-- title, close -->
                  <div class="row full-width q-px-sm justify-between items-center">

                    <!-- title -->
                    <div class="text-subtitle2 text-bold text-grey-9">
                      دسته بندی
                    </div>

                    <!-- close -->
                    <q-btn size="sm" color="grey-9" icon="la la-times" flat round dense
                           @click="categoriesDialog = false"/>

                  </div>

                  <!-- separator -->
                  <q-separator class="q-mx-xs q-my-md"/>

                  <!-- categories -->
                  <q-scroll-area style="height: 300px">
                    <div class="row full-width">
                      <div class="column q-gutter-y-sm text-subtitle2 text-weight-regular">
                        <q-checkbox v-for="(category, index) of categories" class="text-grey-9" size="sm"
                                    :val="category.id"
                                    :label="category.title" color="primary"
                                    :model-value="getFilterValue('projectGroupId',category.id)"
                                    @update:model-value="toggleCategoryFilter(category.id)"/>
                      </div>
                    </div>
                  </q-scroll-area>

                  <!-- confirm -->
                  <q-btn class="full-width border-radius q-mt-md" color="primary" label="تایید" unelevated
                         @click="categoriesDialog = false; loadCampaigns()"/>

                </div>
              </q-dialog>

              <!-- filters -->
              <q-btn class="border-radius q-px-sm" size="12px" icon="la la-filter" label="فیلتر" color="black" flat
                     dense @click="filtersDialog = true"/>

              <q-dialog v-model="filtersDialog" transition-show="scale" transition-hide="scale" full-width>
                <div class="column bg-white q-pa-md" style="border-radius: 10px">

                  <!-- title, close -->
                  <div class="row full-width q-px-sm justify-between items-center">

                    <!-- title -->
                    <div class="text-subtitle2 text-bold text-grey-9">
                      فیلتر
                    </div>

                    <!-- close -->
                    <q-btn size="sm" color="grey-9" icon="la la-times" flat round dense @click="filtersDialog = false"/>

                  </div>

                  <!-- separator -->
                  <q-separator class="q-mx-xs q-my-md"/>

                  <!-- filters -->
                  <div class="row full-width">
                    <div class="column q-gutter-y-xs text-subtitle2 text-weight-regular">
                      <q-radio v-for="filter of progressFilters" class="text-grey-9" size="sm" :val="filter.value"
                               :label="filter.label" color="primary"
                               v-model="selectedFilter" @update:model-value="setProgressFilter"/>
                    </div>
                  </div>

                  <!-- confirm -->
                  <q-btn class="full-width border-radius q-mt-md" color="primary" label="تایید" unelevated
                         @click="filtersDialog = false"/>

                </div>
              </q-dialog>

              <!-- sorting -->
              <q-btn class="border-radius q-px-sm" size="12px" icon="la la-sort-amount-down" label="مرتب‌سازی"
                     color="grey-9" flat dense @click="sortingDialog = true"/>

              <q-dialog v-model="sortingDialog" transition-show="scale" transition-hide="scale" full-width>
                <div class="column bg-white q-pa-md" style="border-radius: 10px">

                  <!-- title, close -->
                  <div class="row full-width q-px-sm justify-between items-center">

                    <!-- title -->
                    <div class="text-subtitle2 text-bold text-grey-9">
                      مرتب سازی
                    </div>

                    <!-- close -->
                    <q-btn size="sm" color="grey-9" icon="la la-times" flat round dense @click="sortingDialog = false"/>

                  </div>

                  <!-- separator -->
                  <q-separator class="q-mx-xs q-my-md"/>

                  <!-- sorting options -->
                  <div class="row full-width text-subtitle2 text-weight-regular">
                    <div class="column q-gutter-y-xs">
                      <q-radio v-for="option of sortingOptions" class="text-grey-9" size="sm" :val="option.value"
                               :label="option.label" color="primary"
                               v-model="selectedSortingOption"
                               @click="setSort(option.value)"
                      />
                    </div>
                  </div>

                  <!-- confirm -->
                  <q-btn class="full-width border-radius q-mt-md" color="primary" label="تایید" unelevated
                         @click="sortingDialog = false"/>

                </div>
              </q-dialog>

            </div>

          </div>

          <!-- results -->
          <div class="row q-col-gutter-md items-center">
            <div v-for="(campaign, index) of campaigns" class="col-12 col-md-4">
              <campaign-item-mobile
                :extra-details="true"
                :id="campaign.id"
                :limited="campaign.isLimited"
                :charity-logo="campaign.charityLogo"
                :title="campaign.title"
                :charity-title="campaign.charityTitle"
                :description="campaign.description"
                :progress="campaign.progress"
                :involvement-rate="campaign.involvementRate"
                :money-raised="campaign.incomeAmount"
                :estimated-cost="campaign.estimatedCost"
                :remaining-days="campaign.remainingDays"
                :sponsor-count="campaign.sponsorCount"
                :status="campaign.statusLookup"
              />
            </div>
          </div>

          <!-- pagination -->
          <div v-if="pagination.totalPages > 1"
               class="row full-width border-radius border-solid bg-white q-py-sm justify-center text-grey-4">
            <q-pagination
              :model-value="pagination.page"
              :max="pagination.totalPages"
              :max-pages="isMobile ? 3 : 9"
              ellipses
              :ripple="false"
              direction-links
              :boundary-links="!isMobile"
              unelevated
              rounded
              color="secondary"
              @update:model-value="changePage"
            />
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import CampaignItemMobile from "../components/CampaignItemMobile";
import CampaignItem from "../components/CampaignItem";
import {useMeta} from "quasar";

export default {
  async preFetch({store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath}) {
    if (ssrContext) {
      await store.dispatch('getMeta', {pageUrl: ssrContext.req.headers.host + currentRoute.path})
    } else {
      await store.dispatch('getMeta', {pageUrl: window.location.host + currentRoute.path})
    }
    let meta = {}
    meta.title = store.state.preFetch?.pageMeta?.metaTitle
    meta.description = store.state.preFetch?.pageMeta?.metaDescription
    meta.keywords = store.state.preFetch?.pageMeta?.metaKeywords
    meta.script = null
    return await store.dispatch('setMeta', meta)
  },
  name: "CampaignSearch",
  components: {
    CampaignItemMobile,
    CampaignItem
  },
  data: () => ({
    isLoading: false,
    baseUrl: process.env.API_URL,
    search: null,
    selectedFilter: 'all',
    selectedSortingOption: 0,
    sorting: '',
    categoriesDialog: false,
    filtersDialog: false,
    sortingDialog: false,
    page: 1,
    pagination: {},
    filters: [],
    campaigns: [{}, {}, {}, {}, {}, {}, {}, {}, {}],
    selectedCategories: [],
    sortingOptions: [
      {label: 'تاریخ', value: ''},
      {label: 'مشارکت', value: 'incomeAmount DESC'},
      {label: 'تعداد حامی', value: 'sponsorCount DESC'}
    ],
    categories: [],
    progressFilters: [
      {label: 'همه', value: 'all'},
      {label: 'جاری', value: 'on-going'},
      {label: 'پایان‌یافته', value: 'finished'}
    ],
  }),
  computed: {
    isMobile() {
      return this.$q.screen.lt.md
    },
    parsedFilters() {
      return JSON.parse(JSON.stringify(this.filters))
    }
  },
  methods: {
    async loadCampaigns() {
      this.isLoading = true
      await this.$router.replace({
        path: this.$route.path,
        query: {page: this.pagination.page || 1, filter: this.encodeFilter(this.filters), sort: this.sorting}
      }).catch(() => {
      })
      let params = {
        page: this.pagination?.page || 1,
        take: 9,
        filter: encodeURIComponent(JSON.stringify(this.filters)),
        sort: this.sorting
      }
      const res = await this.$axios.get(`${process.env.API_URL}/charity/Project/list`, {params})
      this.campaigns = res.data.result.items
      this.pagination.page = res.data.result.pageNo
      this.pagination.totalPages = res.data.result.totalPages
      this.pagination.pageSize = res.data.result.pageSize
      this.pagination.totalCount = res.data.result.totalCount
      this.isLoading = false
    },
    async loadCategories() {
      let params = {filter: encodeURIComponent(JSON.stringify(this.filters))}
      const res = await this.$axios.get(`${process.env.API_URL}/charity/ProjectGroup/all`, {params})
      this.categories = res.data.result
      this.selectedCategories = res.data.result.map(x => false)
    },
    changePage(evt) {
      this.pagination.page = evt
      this.loadCampaigns()
    },
    setSort(option) {
      this.sorting = option
      this.loadCampaigns()
    },
    getFilterValue(name, value) {
      let i = this.parsedFilters?.findIndex(x => x[0] === name)
      if (i > -1) {
        return this.parsedFilters[i][2].findIndex(x => x === value.toString()) > -1
      } else {
        return false
      }
    },
    setFilterFromUrl() {
      this.filters = this.decodeFilter(this.$route.query.filter || '')
      let index = this.parsedFilters?.findIndex(x => x[0] === 'projectGroupId')
      if (index > -1)
        this.selectedCategories = this.filters[index][2].map(x => +x)
      let progressIndex = this.parsedFilters?.findIndex(x => x[0] === 'statusLookup')
      if (progressIndex > -1) {
        if (this.parsedFilters[progressIndex][1] === '=' && this.parsedFilters[progressIndex][2][0] === '1')
          this.selectedFilter = 'on-going'
      }
    },
    decodeFilter(filter) {
      if (filter === null || filter.trim().length <= 0) return []
      return filter.split('_').map(x => {
        let items = x.split(',')
        let mainParts = items.splice(0, 2)
        return [mainParts[0], this.operatorTranslator(mainParts[1]), items]
      })
    },
    encodeFilter(filter) {
      if (!Array.isArray(filter)) return ''
      return filter.map(x => `${x[0]},${this.operatorTranslator(x[1])},${x[2].join(',')}`).join('_') || ''
    },
    operatorTranslator(operator) {
      switch (operator) {
        case '=':
          return 'eq'
        case '!=':
          return 'neq'
        case '>':
          return 'gt'
        case '>=':
          return 'gteq'
        case 'not in':
          return 'notin'
        case 'eq':
          return '='
        case 'neq':
          return '!='
        case 'gt':
          return '>'
        case 'gteq':
          return '>='
        case 'notin':
          return 'not in'
        default:
          return operator
      }
    },
    setFilter(filter) {
      let index = this.filters.findIndex(x => x[0] === filter[0])
      if (index >= 0) {
        if (filter[2] === null || filter[2].length <= 0) {
          this.filters.splice(index, 1)
        } else {
          this.filters[index] = filter
        }
      } else {
        this.filters.push(filter)
      }
    },
    async searchCampaign(event) {
      let filter = ['title', 'like', [event]]
      this.setFilter(filter)
      await this.loadCampaigns()
    },
    async toggleCategoryFilter(val) {
      let i = this.parsedFilters.findIndex(x => x[0])
      let items = []
      if (i > -1) {
        items = this.parsedFilters[i][2]
      }
      let j = items.findIndex(x => x === val.toString())
      if (j > -1) {
        items.splice(j, 1)
      } else {
        items.push(val.toString())
      }
      let filter = ['projectGroupId', 'in', items]
      this.setFilter(filter)
      if (!this.isMobile) {
        this.changePage(1)
        await this.loadCampaigns()
      }
    },
    setProgressFilter() {
      let filter
      if (this.selectedFilter === 'all') {
        filter = ['statusLookup', '=', []]
      } else if (this.selectedFilter === 'on-going') {
        filter = ['statusLookup', '=', ['1']]
      } else filter = ['statusLookup', '>', ['1']]
      this.setFilter(filter)
      this.changePage(1)
      this.loadCampaigns()
    }
  },
  mounted() {
    useMeta(this.$store.state.meta)
    this.setFilterFromUrl()
    this.loadCampaigns()
    this.loadCategories()
    this.$store.commit('setPageLoadState', true)
  }
}
</script>

<style scoped>
h1 {
  font-size: 16px !important;
  line-height: 10px;
}
</style>
